export function normalizeText(str) {
  return str
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function isObject(val) {
  return val && val.constructor === Object;
}
